import { render, staticRenderFns } from "./mycompetition.vue?vue&type=template&id=4d58ed0c&scoped=true&"
import script from "./mycompetition.vue?vue&type=script&lang=js&"
export * from "./mycompetition.vue?vue&type=script&lang=js&"
import style0 from "./mycompetition.vue?vue&type=style&index=0&id=4d58ed0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d58ed0c",
  null
  
)

export default component.exports